import { memo, useContext } from 'react';
import { ResponsivePie } from '@nivo/pie';
import type { PieChart } from '@trinity/chat';
import { LegendCollapseToggleContext } from '@trinity/chat-components/components/Chat/context';
import { ChartHoverText } from './Hover';
import { replaceTemplateValues } from './template-utils';
import { TemplateTooltip } from './TemplateTooltip';
import { theme } from './theme';

type Props = {
  chart: PieChart;
  colors: string[];
};

export const NivoDoughnutChart = memo((props: Props) => {
  const [_open, setOpen] = useContext(LegendCollapseToggleContext);

  const returnedData = props.chart.data;
  const data = [];

  for (let i = 0; i < returnedData.length; i++) {
    data.push({ ...returnedData[i], color: props.colors[i] });
  }

  return (
    <div style={{ height: 320, width: '100%', position: 'relative' }}>
      <ResponsivePie
        data={data}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        colors={props.colors}
        borderWidth={1}
        borderColor={{
          from: 'color',
          modifiers: [
            [
              'darker',
              0.2,
            ],
          ],
        }}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLinkLabelsStraightLength={24}
        arcLabelsTextColor="#FFFFFF"
        tooltip={e => {
          const { datum } = e;
          // If a tooltip template is provided, use it
          if (props.chart.tooltipTemplate) {
            const templateValues = {
              label: datum.label,
              value: datum.value,
              id: datum.id,
              xAxisTitle: props.chart.xAxisTitle,
              yAxisTitle: props.chart.yAxisTitle,
            };
            const content = replaceTemplateValues(props.chart.tooltipTemplate, templateValues);
            return <TemplateTooltip content={content} />;
          }
          // Otherwise use the default tooltip
          return <ChartHoverText name={datum.label} count={datum.value} />;
        }}
        onClick={data => {
          setOpen(true);
        }}
        animate={false}
        theme={theme} />
    </div>

  );
});